import { axiosAzureInstance } from '../Utils/axios';
import type { AxiosResponse } from 'axios';

export const createIncident = async (
  jobId: string,
  argosTaskNumbers: string[],
  description = '',
  deadline: string | null = null
): Promise<AxiosResponse> => {
  const payload = { jobId, argosTaskNumbers, description, deadline };
  return await axiosAzureInstance.post('/webscraper-node/api/servicenow/create-incident', payload);
};

export const getIncidentDetails = async (incidentSysId: string): Promise<AxiosResponse> => {
  return await axiosAzureInstance.get(`/webscraper-node/api/servicenow/incident/${incidentSysId}`);
};

export const getJobIncidents = async (jobId: string): Promise<AxiosResponse> => {
  return await axiosAzureInstance.get(`/webscraper-node/api/servicenow/incidents/job/${jobId}`);
};

export const getAllIncidents = async (page = 1, size = 10): Promise<AxiosResponse> => {
  return await axiosAzureInstance.get(
    `/webscraper-node/api/servicenow/incidents?page=${page}&size=${size}`
  );
};

export const addCommentToIncident = async (
  incidentSysId: string,
  comment: string,
  isWorkNote = false
): Promise<AxiosResponse> => {
  return await axiosAzureInstance.post(
    `/webscraper-node/api/servicenow/incident/${incidentSysId}/comment`,
    { comment, isWorkNote }
  );
};

export const validateJob = async (jobId: string): Promise<AxiosResponse> => {
  return await axiosAzureInstance.post('/webscraper-node/api/servicenow/validate-job', { jobId });
};

export const testConnection = async (): Promise<AxiosResponse> => {
  return await axiosAzureInstance.get('/webscraper-node/api/servicenow/health');
};

const ServiceNowService = {
  createIncident,
  getIncidentDetails,
  getJobIncidents,
  getAllIncidents,
  addCommentToIncident,
  validateJob,
  testConnection,
};

export default ServiceNowService;
